import { InputProptypes, wrap } from 'components/form/InputWrapper'
import { forwardRef } from 'react'

const PasswordInput = forwardRef(
  (
    {
      id,
      name,
      value,
      defaultValue,
      onFocus,
      onBlur,
      onChange,
      onError,
      maxLength,
    },
    ref
  ) => (
    <input
      type="password"
      className="inp_txt"
      id={id}
      name={name}
      value={value}
      defaultValue={defaultValue}
      ref={ref}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={onChange}
      maxLength={maxLength}
    />
  )
)

PasswordInput.propTypes = InputProptypes
PasswordInput.displayName = 'PasswordInput'

export default wrap(PasswordInput)
